/**
 * Co-Producer / Touring Partner / Project Partner form
 */

import $ from 'jquery';
import _ from 'lodash';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import refreshToken from '../mixins/refresh-token';

const dictionary = { en: { messages: { required: 'This field is mandatory' } } };

VeeValidate.Validator.localize(dictionary);

Vue.use(VeeValidate);

const formPrizeComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-prize',

    props: [
        'token',
        'previous',
        'action',
        'id',
        'projectData',
        'prizes',
        'readOnly',
        'next',
        'errorBags'
    ],

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            project: {},
            tokenVal: null
        };

        return dataObject;
    },

    methods: {
        validateForm (e) {
            e.preventDefault();
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    let btnSpinner = $('.btn--spinner', e.target);

                    btnSpinner.addClass('right-spin');
                    e.target.submit();
                } else {
                    let fieldName = this.errors.items[0].field;

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('[name="' + fieldName + '"]').parent()
                            .offset().top - 130
                    }, 500);
                }
            })
                .catch(() => {
                    return false;
                });
        }
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        this.project = this.projectData;
        this.tokenVal = this.token;
    },

    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            const field = this.$validator.fields.find({
                name: fieldname,
                scope: this.$options.scope
            });

            this.$validator.errors.add({
                id: field.name,
                field: field.name,
                msg: value[0],
                scope: this.$options.scope
            });

            field.setFlags({
                invalid: true,
                valid: false,
                validated: true
            });
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    }

};

const formPrizeComponent = Vue.extend(formPrizeComponentConfig);

export default formPrizeComponent;
